module.exports = __webpack_public_path__ + "img/nuevos-cocteles.6bf2cbbc.png";